import Err from '@leverege/error'
import Prom from '@leverege/promise'
import FieldFactory from './FieldFactory.js'
import Util from './Util.js'

const openers = /^[({'"[]$/
const closers = /^[)}'"\]]$/
const closeMatches = {
  '(' : ')',
  '{' : '}',
  '\'' : '\'',
  '"' : '"',
  '[' : ']',
}

export default {
  id : 'Expression.FieldParser.RootField',
  type : 'rootField',
  sort : -10000,
  handles : ( field, context ) => typeof field === 'string',
  parse : async ( fieldList, context ) => {
    const indexOffsetFactor = ( context?.field?.startIndex || 0 ) + ( context?.indexOffset || 0 )
    const fields = [], stack = [], commaLocations = []
    let field = ''
    for ( let i = 0; i < fieldList.length; i++ ) {
      const char = fieldList[i]
      if ( char.match( openers ) ) {
        stack.push( char )
      }
      if ( char.match( closers ) ) {
        if ( closeMatches[stack.at( -1 )] !== char ) {
          return Util.handleInvalid(
            {
              type : 'ExpressionParser.Field',
              value : field.trim(),
              startIndex : i - field.length + indexOffsetFactor,
              endIndex : i + indexOffsetFactor,
              untrimmed : field
            },
            Err.illegalArgument( { message : 'bad string: unmatched parentheses', index : i, field : field + char, fieldList, context } ),
            context
          )
        }
        stack.pop()
      }
      if ( char === ',' && stack.length === 0 ) {
        const trimmed = field.trim()
        const frontRemoved = field.indexOf( trimmed )
        const endRemoved = field.length - trimmed.length - frontRemoved
        fields.push( {
          type : 'ExpressionParser.Field',
          value : field.trim(),
          startIndex : i - field.length + indexOffsetFactor + frontRemoved,
          endIndex : i + indexOffsetFactor - endRemoved,
          untrimmed : field
        } )
        commaLocations.push( {
          relative : i,
          absolute : i + indexOffsetFactor,
        } )
        field = ''
      } else {
        field += char
      }
    }
    if ( stack.length !== 0 ) {
      return Util.handleInvalid(
        {
          type : 'ExpressionParser.Field',
          value : field.trim(),
          startIndex : fieldList.length - field.length + indexOffsetFactor,
          endIndex : fieldList.length + indexOffsetFactor,
          untrimmed : field
        },
        Err.illegalArgument( { message : 'bad string: unmatched parentheses', index : fieldList.length - 1, fieldList, context } ),
        context
      )
    }
    if ( field.length > 0 ) {
      const trimmed = field.trim()
      const frontRemoved = field.indexOf( trimmed )
      const endRemoved = field.length - trimmed.length - frontRemoved
      fields.push( {
        type : 'ExpressionParser.Field',
        value : field.trim(),
        startIndex : fieldList.length - field.length + indexOffsetFactor + frontRemoved,
        endIndex : fieldList.length + indexOffsetFactor - endRemoved,
        untrimmed : field
      } )
    }

    const parent = {
      ...context.field,
      parent : context.parent
    }
    const toReturn = {
      type : 'ExpressionField.Root',
      fields : await Prom.mapLimit(
        fields,
        fld => FieldFactory.create(
          fld,
          { ...context, indexOffset : 0, parent, field : fld }
        )
      )
    }
    if ( context?.includeAstInfo ) {
      toReturn.commaLocations = commaLocations
    }
    return toReturn
  }
}
